import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// ----- Imports ----- //
import { css } from '@emotion/react';
import { from, headlineMedium28, neutral, space, until, } from '@guardian/source/foundations';
import { Accordion } from '@guardian/source/react-components';
import FlexContainer from 'components/containers/flexContainer';
import GridImage from 'components/gridImage/gridImage';
import { TabAccordionRow } from './tabAccordionRow';
const flexContainerOverride = css `
	align-items: flex-start;
	justify-content: space-between;

	img {
		${until.leftCol} {
			display: none;
		}
	}
`;
const faqsContainer = css `
	${from.leftCol} {
		max-width: 50%;
	}
`;
const paragraph = css `
	margin-bottom: ${space[6]}px;
	${until.tablet} {
		padding: 0 ${space[2]}px;
	}

	a {
		color: inherit;
	}
`;
export const accordionContainer = css `
	background-color: ${neutral['97']};

	p,
	a {
		${headlineMedium28};
		margin-bottom: ${space[3]}px;
	}

	p,
	button {
		padding-right: ${space[2]}px;
		padding-left: ${space[2]}px;
	}
`;
// ----- Content ----- //
const accordionTrackingId = 'Paper_HomeDelivery-tab_Delivery-accordion';
export function ContentDeliveryFaqBlock() {
    return (_jsxs(FlexContainer, { cssOverrides: flexContainerOverride, children: [_jsxs("div", { css: faqsContainer, children: [_jsx("p", { css: paragraph, children: "Use the Guardian\u2019s home delivery service to get our newspaper direct to your door." }), _jsx("p", { css: paragraph, children: "Select your subscription below and checkout. You'll receive your first newspaper as quickly as five days from subscribing." }), _jsx("div", { css: accordionContainer, children: _jsx(Accordion, { children: [
                                _jsxs(TabAccordionRow, { trackingId: accordionTrackingId, label: "Delivery details", children: [_jsx("p", { children: "Your newspaper will arrive before 9am." }), _jsx("p", { children: "We can\u2019t deliver to individual flats, or apartments within blocks because we need access to your post box to deliver your newspaper." }), _jsx("p", { children: "You can pause your subscription for up to 5 weeks a year. So if you\u2019re going away anywhere, you won\u2019t have to pay for the newspapers that you miss." })] }),
                            ] }) })] }), _jsx(GridImage, { gridId: "printCampaignHDdigitalVoucher", srcSizes: [500, 140], sizes: "(max-width: 740px) 100vw, 500px", imgType: "png" })] }));
}
